import { FilterParams } from '@synergy/models';
import { FormattedMessage } from 'react-intl';
import { ReactElement } from 'react';
import { Stack } from '@mui/material';
import { useSearchParams } from 'react-router-dom';

import { FilterChip } from '../../../../components/filter';
import { SupplierSearchCount } from '../../../../models/supplier-search-count';
import { initialArticleSearchResultsSelector } from '../../../../store/articles-selectors';
import { useAppSelector } from '../../../../../store/store';

export const SupplierFilterChips = (): ReactElement | null => {
    const [searchParams, setSearchParams] = useSearchParams();
    const supplierIds = searchParams.get(FilterParams.SupplierIds);
    const { suppliersFromSearch } = useAppSelector(initialArticleSearchResultsSelector);

    if (!supplierIds) return null;

    const suppliers =
        suppliersFromSearch?.reduce((acc: SupplierSearchCount[], supplier: SupplierSearchCount) => {
            if (supplierIds.split(',').some(id => id === supplier.id.toString())) {
                acc.push(supplier);
            }
            return acc;
        }, [] as SupplierSearchCount[]) ?? [];

    const handleChipDelete = (supplier: SupplierSearchCount): void => {
        let supplierIds = searchParams.get(FilterParams.SupplierIds)?.split(',');
        if (supplierIds?.some(id => id === supplier.id.toString())) {
            supplierIds = supplierIds.filter(id => id !== supplier.id.toString());
            if (supplierIds.length === 0) {
                searchParams.delete(FilterParams.SupplierIds);
            } else {
                searchParams.set(FilterParams.SupplierIds, supplierIds.join(','));
            }
        } else {
            searchParams.set(FilterParams.SupplierIds, [...(supplierIds ?? []), supplier.id].join(','));
        }
        setSearchParams(searchParams);
    };

    return (
        <>
            {suppliers.map(supplier => {
                return (
                    <FilterChip
                        key={supplier.id}
                        label={
                            <Stack direction="row" gap={0.5}>
                                <strong>
                                    <FormattedMessage id="app.filter.supplier.label" />
                                </strong>
                                <span>{supplier.name}</span>
                            </Stack>
                        }
                        onChipDelete={() => handleChipDelete(supplier)}
                    />
                );
            })}
        </>
    );
};
